import React, { Component } from "react";
import { Helmet } from "react-helmet";
// import _ from "lodash";
import { Route, Switch, Link } from "react-router-dom";
import { UserContext } from "../../Context";

import Favs from "../favs/Favs";
import Loading from "../../components/loading/Loading";
import LoggedOutContent from "../../components/LoggedOutContent/LoggedOutContent";
// import MyTable from "../../components/myTable/MyTable";
import MyApplicationsTable from "../../components/myApplicationsTable/MyApplicationsTable";

import Button from "@atlaskit/button";

import "./my.css";
export default class My extends Component {
  render() {
    return (
      <UserContext.Consumer>
        {userContext => {
          const my = userContext.my || {};
          const favs = my.favs || {};
          return (
            <div className="my padded-body">
              <Helmet>
                <title>{`My `}</title>
              </Helmet>
              {userContext.userLoading && (
                <div className="my-loading full-body-content">
                  <Loading />
                </div>
              )}
              {!userContext.userLoading &&
                !userContext.user && (
                  <div className="my__login">
                    <LoggedOutContent />
                  </div>
                )}
              {!userContext.userLoading &&
                !!userContext.user && (
                  <Switch>
                    <Route
                      exact
                      path="/my"
                      render={props => (
                        <div>
                          <Link
                            className="my__nav-link-btn"
                            to={`/my/applications`}
                          >
                            <Button shouldFitContainer>Applications</Button>
                          </Link>
                          <Link className="my__nav-link-btn" to={`/my/favs`}>
                            <Button shouldFitContainer>Favourites</Button>
                          </Link>
                        </div>
                      )}
                    />
                    <Route
                      exact
                      path="/my/applications"
                      render={() => (
                        <div className="my-container">
                          <Helmet>
                            <title>{`My Applications`}</title>
                          </Helmet>
                          <div className="my-body">
                            <MyApplicationsTable
                              addFlag={userContext.addFlag}
                            />
                          </div>
                        </div>
                      )}
                    />
                    <Route
                      exact
                      path="/my/favs"
                      render={() => (
                        <div className="my-container">
                          <Helmet>
                            <title>{`My Favourites`}</title>
                          </Helmet>
                          <div className="my-body">
                            <Favs favs={favs} addFlag={userContext.addFlag} />
                          </div>
                        </div>
                      )}
                    />
                  </Switch>
                )}
            </div>
          );
        }}
      </UserContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/my/My.js